module.exports = __webpack_public_path__ + "static/img/img-app1.72af6c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img-app1.png
// module id = hXf4
// module chunks = 1